import { useCallback } from 'react'
import { Emoji } from '@evertel/web/emojis'
import { APIDataEmoji } from '@evertel/types'

type OptionProps = {
    option: string
    messageId?: number
    params?: any
}

interface EmojiListProps {
    emojis: { text: string}[]
    messageId: number
    onClickOption: (option: OptionProps) => void
}

export const EmojiList: React.FC<EmojiListProps> = ({
    emojis,
    messageId,
    onClickOption
}) => {

    const onClickFrequentReactions = useCallback((event, emoji) => {
        event.stopPropagation()
        onClickOption({
            option: 'reaction',
            messageId,
            params: emoji
        })
    }, [messageId, onClickOption])

    if (emojis?.length <= 0) {
        return null
    }

    return (
        <div className="frequent-reactions">
            {emojis.map((emoji, idx) =>
                <button
                    key={idx}
                    className="option emoji-list-item"
                    onClick={(event) => onClickFrequentReactions(event, emoji)}
                >
                    <Emoji
                        emoji={emoji.text}
                    />
                </button>
            )}
        </div>
    )
}
